import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import AttivaCard from '../../../components/card/AttivaCard';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useHandleErrors from '../../../hooks/useHandleErrors';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import { ClientService } from '../../../services/client/clientService';
import ClientForm from '../ClientForm';

const pageHeader = {
    title: 'Crear Cliente',
    breadcrumb: [
        { name: 'Ventas' },
        { name: 'Gestión de clientes' },
        { href: menuRoutes.clients.path, name: 'Clientes' },
        { name: 'Crear' },
    ],
};

export default function ClientCreate() {

    const { handleErrors } = useHandleErrors();
    const { isFacilitatorManager } = usePrivilege();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!isFacilitatorManager) return;
        toast.error('El perfil Manager Dinamizador no puede crear clientes');
        navigate(menuRoutes.clients.path, { replace: true });
    }, [isFacilitatorManager, navigate]);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = await (await (new ClientService()).createClient(values)).getResponseData();
            if (response.success) {
                setLoading(false);
                navigate(-1);
                setTimeout(() => { toast.success('Cliente creado correctamente') }, 100);
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title='Datos Principales'>
                <ClientForm submit={handleSubmit} isLoading={loading} />
            </AttivaCard>
        </>
    );
}
